import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CrudService } from 'src/app/core/services/crud.service';
import { fetchUsersList, fetchUsersListSuccess, fetchUsersListFailure, activeDeactiveUser, activeDeactiveUserSuccess, activeDeactiveUserFailure } from './users.action';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class UsersEffects {
  constructor(
    private actions$: Actions,
    private CrudService: CrudService,
    private snackBar: MatSnackBar
  ) {}

  fetchData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchUsersList),
      mergeMap((action:any) =>
        this.CrudService.fetchData(
          `Admin/GetUsers?PageNumber=${action.payload.pageNumber}&PageSize=${action.payload.pageSize}
          &SortColumn=${action.payload.sortColumn}&SortOrder=${action.payload.sortOrder}&Search=${action.payload.search}`).pipe(
          map((result) => fetchUsersListSuccess({ response: result })),

          catchError((error) => of(fetchUsersListFailure({ error })))
        )
      )
    )
  );

  activeDeactiveUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(activeDeactiveUser),
      mergeMap((action:any) =>
        this.CrudService.putData('Admin/ActivateOrDeactivateUser',action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.open('User Status Updated successfully', '', {
                duration: 3000,
                panelClass: 'success',
              });
            } else {
              this.snackBar.open(result.message, '', {
                duration: 3000,
                panelClass: 'danger',
              });
            }
          }),
          mergeMap((res) => [
            activeDeactiveUserSuccess({ response: res.result }),
            fetchUsersList({
              payload: { pageNumber: 1, pageSize: 10, sortColumn: 'id', sortOrder: 'z', search: '' }
            })
          ]),
          catchError((error) => of(activeDeactiveUserFailure({ error })))
        )
      )
    )
  );

}
